import { createStyles, makeStyles, Theme } from '@material-ui/core';

export default makeStyles((theme: Theme) => {
  return createStyles({
    container: {
      display: 'flex',
      alignItems: 'flex-start',
      paddingBottom: '1.5rem',
      lineHeight: '1.625rem',
    },
    icon: {
      color: theme.palette.primary.main,
      paddingRight: '1rem',
    },
    copiedText: {
      fontSize: '0.75rem',
    },
  });
});
